export const activitiesUnga = [
  {
    'taxonomy': -1,
    'name': 'Inget Loggat',
    'name_EN': 'Nothing Logged',
    'category': 'Inget Loggat',
    'subCategory': 'Inget Loggat',
    'keywords': ['Inget Loggat'],
    'frequency': 0,
    'quickSelection': false,
  },
  // EGENOMSORG – ta hand om sig själv
  {
    'taxonomy': 10,
    'name': 'Vakna',
    'name_EN': 'Wake up',
    'category': 'Egenomsorg',
    'subCategory': 'Ta hand om sig själv',
    'keywords': ['Vakna', 'Vaken', 'Morgon'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 20,
    'name': 'Äta',
    'name_EN': 'Eat',
    'category': 'Egenomsorg',
    'subCategory': 'Ta hand om sig själv',
    'keywords': ['Äta', 'Mat', 'Käka'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 30,
    'name': 'Lägga sig',
    'name_EN': 'Go to bed',
    'category': 'Egenomsorg',
    'subCategory': 'Ta hand om sig själv',
    'keywords': ['Lägga sig', 'Sova', 'Kväll', 'Natt'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 40,
    'name': 'Sömn',
    'name_EN': 'Sleep',
    'category': 'Egenomsorg',
    'subCategory': 'Ta hand om sig själv',
    'keywords': ['Sömn', 'Sova', 'Natt'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 50,
    'name': 'Hygien',
    'name_EN': 'Hygiene',
    'category': 'Egenomsorg',
    'subCategory': 'Ta hand om sig själv',
    'keywords': ['Hygien', 'Tvätta', 'Duscha', 'Bad'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 60,
    'name': 'Träning',
    'name_EN': 'Exercise',
    'category': 'Egenomsorg',
    'subCategory': 'Ta hand om sig själv',
    'keywords': ['Träning', 'Träna', 'Motion', 'Gym'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 70,
    'name': 'Annat (Egenomsorg)',
    'name_EN': 'Other (Self-care)',
    'category': 'Egenomsorg',
    'subCategory': 'Ta hand om sig själv',
    'keywords': ['Annat', 'Övrigt'],
    'frequency': 0,
    'quickSelection': false,
  },
  // OMVÅRDNAD – ta hand om andra människor/djur
  {
    'taxonomy': 100,
    'name': 'Hjälpa/stödja annan',
    'name_EN': 'Help/support another',
    'category': 'Omvårdnad',
    'subCategory': 'Ta hand om andra',
    'keywords': ['Hjälpa', 'Stödja', 'Stöd', 'Hjälp'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 110,
    'name': 'Sköta, ta hand om djur',
    'name_EN': 'Take care of animals',
    'category': 'Omvårdnad',
    'subCategory': 'Ta hand om andra',
    'keywords': ['Djur', 'Husdjur', 'Sköta', 'Mata'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 120,
    'name': 'Trösta',
    'name_EN': 'Comfort',
    'category': 'Omvårdnad',
    'subCategory': 'Ta hand om andra',
    'keywords': ['Trösta', 'Stöd', 'Hjälpa'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 130,
    'name': 'Annat (Omvårdnad)',
    'name_EN': 'Other (Care)',
    'category': 'Omvårdnad',
    'subCategory': 'Ta hand om andra',
    'keywords': ['Annat', 'Övrigt'],
    'frequency': 0,
    'quickSelection': false,
  },
  // HUSHÅLLSARBETE
  {
    'taxonomy': 200,
    'name': 'Städa',
    'name_EN': 'Clean',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Städa', 'Städning', 'Rengöra'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 210,
    'name': 'Tvätta',
    'name_EN': 'Laundry',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Tvätta', 'Tvätt', 'Kläder'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 220,
    'name': 'Trädgård',
    'name_EN': 'Garden',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Trädgård', 'Plantera', 'Gräs'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 230,
    'name': 'Handla/Förbereda mat',
    'name_EN': 'Shop/Prepare food',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Handla', 'Förbereda', 'Mat', 'Inköp'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 240,
    'name': 'Laga mat',
    'name_EN': 'Cook',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Laga mat', 'Matlagning', 'Koka'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 250,
    'name': 'Baka',
    'name_EN': 'Bake',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Baka', 'Bakning', 'Kakor'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 260,
    'name': 'Diska',
    'name_EN': 'Wash dishes',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Diska', 'Disk', 'Rengöra'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 270,
    'name': 'Annat (Hushållsarbete)',
    'name_EN': 'Other (Household)',
    'category': 'Hushållsarbete',
    'subCategory': 'Hushållsarbete',
    'keywords': ['Annat', 'Övrigt'],
    'frequency': 0,
    'quickSelection': false,
  },
  // MÅLTIDER
  {
    'taxonomy': 300,
    'name': 'Frukost',
    'name_EN': 'Breakfast',
    'category': 'Måltider',
    'subCategory': 'Måltider',
    'keywords': ['Frukost', 'Morgon', 'Äta'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 310,
    'name': 'Mellanmål/fika',
    'name_EN': 'Snack/Coffee break',
    'category': 'Måltider',
    'subCategory': 'Måltider',
    'keywords': ['Mellanmål', 'Fika', 'Snack'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 320,
    'name': 'Lunch',
    'name_EN': 'Lunch',
    'category': 'Måltider',
    'subCategory': 'Måltider',
    'keywords': ['Lunch', 'Middag', 'Äta'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 330,
    'name': 'Middag',
    'name_EN': 'Dinner',
    'category': 'Måltider',
    'subCategory': 'Måltider',
    'keywords': ['Middag', 'Äta', 'Kväll'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 340,
    'name': 'Kvällsmål',
    'name_EN': 'Evening meal',
    'category': 'Måltider',
    'subCategory': 'Måltider',
    'keywords': ['Kvällsmål', 'Kvällsmat', 'Natt'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 350,
    'name': 'Annat (Måltider)',
    'name_EN': 'Other (Meals)',
    'category': 'Måltider',
    'subCategory': 'Måltider',
    'keywords': ['Annat', 'Övrigt'],
    'frequency': 0,
    'quickSelection': false,
  },
  // FÖRFLYTTNINGAR
  {
    'taxonomy': 400,
    'name': 'Gå/promenera',
    'name_EN': 'Walk',
    'category': 'Förflyttningar',
    'subCategory': 'Förflyttningar',
    'keywords': ['Gå', 'Promenera', 'Promenad'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 410,
    'name': 'Cykel',
    'name_EN': 'Bicycle',
    'category': 'Förflyttningar',
    'subCategory': 'Förflyttningar',
    'keywords': ['Cykel', 'Cykla', 'Cykeln'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 420,
    'name': 'Elspark',
    'name_EN': 'Electric scooter',
    'category': 'Förflyttningar',
    'subCategory': 'Förflyttningar',
    'keywords': ['Elspark', 'Elsparkcykel', 'Scooter'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 430,
    'name': 'Bil',
    'name_EN': 'Car',
    'category': 'Förflyttningar',
    'subCategory': 'Förflyttningar',
    'keywords': ['Bil', 'Köra', 'Åka'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 440,
    'name': 'Kollektivtrafik',
    'name_EN': 'Public transport',
    'category': 'Förflyttningar',
    'subCategory': 'Förflyttningar',
    'keywords': ['Kollektivtrafik', 'Buss', 'Tåg', 'Tunnelbana'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 450,
    'name': 'Annat (Förflyttningar)',
    'name_EN': 'Other (Transport)',
    'category': 'Förflyttningar',
    'subCategory': 'Förflyttningar',
    'keywords': ['Annat', 'Övrigt'],
    'frequency': 0,
    'quickSelection': false,
  },
  // BOENDEAKTIVITETER
  {
    'taxonomy': 500,
    'name': 'Skola',
    'name_EN': 'School',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Skola', 'Lektion', 'Utbildning'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 510,
    'name': 'Praktik/jobb',
    'name_EN': 'Internship/work',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Praktik', 'Jobb', 'Arbete'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 520,
    'name': 'Läxläsning',
    'name_EN': 'Homework',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Läxläsning', 'Läxor', 'Studera'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 530,
    'name': 'Behandling',
    'name_EN': 'Treatment',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Behandling', 'Terapi', 'Vård'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 540,
    'name': 'Träning/sport',
    'name_EN': 'Exercise/sports',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Träning', 'Sport', 'Gym', 'Fotboll', 'Ridning', 'Simning', 'Fiska'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 550,
    'name': 'Pyssel',
    'name_EN': 'Crafts',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Pyssel', 'Pyssla', 'Kreativ'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 560,
    'name': 'TV',
    'name_EN': 'TV',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['TV', 'Titta', 'Film', 'Serie'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 570,
    'name': 'Spel',
    'name_EN': 'Games',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Spel', 'Spela', 'Dataspel', 'TV-spel'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 580,
    'name': 'Utflykt',
    'name_EN': 'Outing',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Utflykt', 'Bio', 'Kafé', 'Café'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 590,
    'name': 'Handla, klippning',
    'name_EN': 'Shopping, haircut',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Handla', 'Klippning', 'Shopping', 'Frisör'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 600,
    'name': 'Röka',
    'name_EN': 'Smoke',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Röka', 'Rökning', 'Cigarett'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 610,
    'name': 'Vara med vänner',
    'name_EN': 'Be with friends',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Vänner', 'Kompisar', 'Umgås'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 620,
    'name': 'Kolla på mobilen',
    'name_EN': 'Check phone',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Mobil', 'Telefon', 'Mobilen', 'Prata'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 630,
    'name': 'Besök av eller hos förälder/rar',
    'name_EN': 'Visit with parent(s)',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Besök', 'Förälder', 'Föräldrar', 'Mamma', 'Pappa'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 640,
    'name': 'Annat (Boendeaktiviteter)',
    'name_EN': 'Other (Living activities)',
    'category': 'Boendeaktiviteter',
    'subCategory': 'Boendeaktiviteter',
    'keywords': ['Annat', 'Övrigt'],
    'frequency': 0,
    'quickSelection': false,
  },
  // MÖTEN
  {
    'taxonomy': 700,
    'name': 'Möte med personal och/eller ungdomar',
    'name_EN': 'Meeting with staff and/or youth',
    'category': 'Möten',
    'subCategory': 'Möten',
    'keywords': ['Möte', 'Personal', 'Ungdomar'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 710,
    'name': 'Möte med socialtjänst',
    'name_EN': 'Meeting with social services',
    'category': 'Möten',
    'subCategory': 'Möten',
    'keywords': ['Möte', 'Socialtjänst', 'Soc'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 720,
    'name': 'Med annan myndighet',
    'name_EN': 'With other authority',
    'category': 'Möten',
    'subCategory': 'Möten',
    'keywords': ['Myndighet', 'Möte'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 730,
    'name': 'Annat (Möten)',
    'name_EN': 'Other (Meetings)',
    'category': 'Möten',
    'subCategory': 'Möten',
    'keywords': ['Annat', 'Övrigt'],
    'frequency': 0,
    'quickSelection': false,
  },
  // SAMTAL
  {
    'taxonomy': 800,
    'name': 'Inplanerade sedan tidigare',
    'name_EN': 'Pre-scheduled',
    'category': 'Samtal',
    'subCategory': 'Samtal',
    'keywords': ['Inplanerad', 'Planerad', 'Samtal'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 810,
    'name': 'Oplanerade/spontana',
    'name_EN': 'Unplanned/spontaneous',
    'category': 'Samtal',
    'subCategory': 'Samtal',
    'keywords': ['Oplanerad', 'Spontan', 'Samtal'],
    'frequency': 0,
    'quickSelection': false,
  },
];
